import React from 'react';

import Layouts from 'components/Layouts';
import CertificationBody from 'modules/certification-body';
import PageHeader from 'components/Pages/PageHeader';

function Index() {
  return (
    <Layouts header={false} footer>
      <PageHeader logoSize="lg" fluid={false} fixed={false} sticky />
      <CertificationBody />
    </Layouts>
  );
}

export default Index;
